(function () {
  var SELECTOR = '[data-sport-edit-carousel]';
  var REDUCE = '(prefers-reduced-motion: reduce)';
  var DEFAULT_INTERVAL = 4500;
  var instances = [];

  function readMs(value, fallback) {
    var n = parseInt(value, 10);
    return n > 0 ? n : fallback;
  }

  function SportEditCarousel(root) {
    this.root = root;
    this.slides = Array.prototype.slice.call(root.querySelectorAll('[data-sport-edit-slide]'));
    this.index = 0;
    this.timer = null;
    this.interval = readMs(root.getAttribute('data-interval'), DEFAULT_INTERVAL);
    this.reduceMq = window.matchMedia(REDUCE);
    this.boundReduce = this.onReduceChange.bind(this);
    this.boundVisibility = this.onVisibility.bind(this);

    if (this.reduceMq.addEventListener) this.reduceMq.addEventListener('change', this.boundReduce);
    else this.reduceMq.addListener(this.boundReduce);
    document.addEventListener('visibilitychange', this.boundVisibility);

    this.show(0);
    this.sync();
  }

  SportEditCarousel.prototype.show = function (index) {
    if (!this.slides.length) return;
    this.index = ((index % this.slides.length) + this.slides.length) % this.slides.length;
    this.slides.forEach(function (slide, i) {
      if (i === this.index) slide.classList.add('is-active');
      else slide.classList.remove('is-active');
    }, this);
  };

  SportEditCarousel.prototype.next = function () {
    this.show(this.index + 1);
  };

  SportEditCarousel.prototype.start = function () {
    var self = this;
    this.stop();
    if (this.slides.length < 2) return;
    this.timer = window.setInterval(function () {
      self.next();
    }, this.interval);
  };

  SportEditCarousel.prototype.stop = function () {
    if (this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  };

  SportEditCarousel.prototype.sync = function () {
    if (this.reduceMq.matches || document.hidden) {
      this.stop();
      this.show(0);
      return;
    }
    this.start();
  };

  SportEditCarousel.prototype.onReduceChange = function () {
    if (this.reduceMq.matches) {
      this.stop();
      this.show(0);
    } else {
      this.start();
    }
  };

  SportEditCarousel.prototype.onVisibility = function () {
    if (document.hidden) this.stop();
    else this.sync();
  };

  SportEditCarousel.prototype.destroy = function () {
    this.stop();
    if (this.reduceMq.removeEventListener) this.reduceMq.removeEventListener('change', this.boundReduce);
    else this.reduceMq.removeListener(this.boundReduce);
    document.removeEventListener('visibilitychange', this.boundVisibility);
  };

  function mount(scope) {
    var nodes = (scope || document).querySelectorAll(SELECTOR);
    Array.prototype.forEach.call(nodes, function (node) {
      if (node.getAttribute('data-sport-edit-ready') === 'true') return;
      node.setAttribute('data-sport-edit-ready', 'true');
      instances.push(new SportEditCarousel(node));
    });
  }

  function unmount(scope) {
    var remaining = [];
    instances.forEach(function (instance) {
      if (!scope || scope === document || scope.contains(instance.root)) {
        instance.root.removeAttribute('data-sport-edit-ready');
        instance.destroy();
      } else {
        remaining.push(instance);
      }
    });
    instances = remaining;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { mount(document); });
  } else {
    mount(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    unmount(event.target);
    mount(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    unmount(event.target);
  });
})();
